import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ScoreParamsUI from '../../../components/superUser/score/ScoreParamsUI'
import ChequeBounceUI from '../../../components/superUser/score/ChequeBounceUI'

const ScoreParamsPageUI = ({
  context, account, params, provisionalYear, onRefreshClick,
  updateMode, updClk, onCancelClick, onUpdate,
  showUnused, onShowUnusedCick, onHideUnusedCick,
  allYrs, onShowAllClick, onShowRecentClick,
  updateProvisionalsMode, onUpdateProvisionals,
  // update form variables
  parameterName, financialYear, parameterValue,
  //
  toggleEditable, edit,
  onToggleMcaItr, itr, onToggleClassicStp, stp
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account} account={account} page='scoreParams'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <ScoreParamsUI
          context={context} account={account} params={params} provisionalYear={provisionalYear} onRefreshClick={onRefreshClick}
          updateMode={updateMode} updClk={updClk} onCancelClick={onCancelClick} onUpdate={onUpdate}
          showUnused={showUnused} onShowUnusedCick={onShowUnusedCick} onHideUnusedCick={onHideUnusedCick}
          allYrs={allYrs} onShowAllClick={onShowAllClick} onShowRecentClick={onShowRecentClick}
          updateProvisionalsMode={updateProvisionalsMode} onUpdateProvisionals={onUpdateProvisionals}
          parameterName={parameterName} financialYear={financialYear} parameterValue={parameterValue}
          toggleEditable={toggleEditable} edit={edit}
          onToggleMcaItr={onToggleMcaItr} itr={itr} onToggleClassicStp={onToggleClassicStp} stp={stp}
        />
        <div className='g_m_top_200' />
        <ChequeBounceUI context={context} account={account} params={params} />
        {/* <ScoreParamsSMSF context={context} account={account} /> */}
      </div>
    }
  </SuperUserAccountPageUI>

export default ScoreParamsPageUI
